<!-- HEADER -->
<div (click)="moveToFolderMenuId = null">
<div class="mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
  <div>
    <h1 class="text-[1.75rem] font-bold text-gray-900 dark:text-white leading-tight">Correo de marketing</h1>
    <p class="text-sm text-gray-500 dark:text-gray-400">{{ campaigns.length }} correos de marketing</p>
  </div>
  <div class="flex flex-wrap items-center gap-2">
    <button (click)="openBulkModal()"
            class="inline-flex items-center gap-2 rounded-md border border-gray-300 dark:border-gray-700 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      Canal bulk
      @if (bulkChannel) {
        <span class="hidden md:inline text-xs text-teal-600 dark:text-teal-400">· {{ bulkChannel.displayName }}</span>
      }
    </button>
    <button (click)="toggleFolderPanel()"
            class="inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-colors"
            [class.bg-brand-500]="folderPanelOpen"
            [class.text-white]="folderPanelOpen"
            [class.hover:bg-brand-600]="folderPanelOpen"
            [class.border]="!folderPanelOpen"
            [class.border-brand-400]="!folderPanelOpen"
            [class.text-brand-500]="!folderPanelOpen"
            [class.dark:text-brand-400]="!folderPanelOpen"
            [class.dark:border-brand-500]="!folderPanelOpen"
            [class.hover:bg-brand-50]="!folderPanelOpen"
            [class.dark:hover:bg-brand-900\/20]="!folderPanelOpen">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
      </svg>
      Carpetas
      @if (folders.length > 0) {
        <span class="rounded-full px-1.5 text-[10px] font-semibold"
              [class.bg-white]="folderPanelOpen"
              [class.text-brand-500]="folderPanelOpen"
              [class.bg-brand-100]="!folderPanelOpen"
              [class.text-brand-600]="!folderPanelOpen">
          {{ folders.length }}
        </span>
      }
    </button>
    <button *appHasPermission="'campaigns:create'" (click)="newCampaign()"
            class="inline-flex items-center gap-2 rounded-md bg-brand-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-600 transition-colors">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Crear correo
    </button>
  </div>
</div>

<!-- Channel warnings -->
@if (!hasConnectedChannels && !loading) {
  <div class="mb-4 flex items-start gap-2 rounded-lg border border-error-200 bg-error-50 p-3 text-sm text-error-700 dark:border-error-700 dark:bg-error-900/20 dark:text-error-300">
    <svg class="mt-0.5 h-4 w-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
    </svg>
    <p class="flex-1">No tienes ningún canal de envío conectado: los correos no podrán enviarse.
      <a routerLink="/correo/canales" class="underline font-medium">Conecta un canal en Canales de comunicación</a>.
    </p>
  </div>
} @else if (!bulkChannel && !loading) {
  <div class="mb-4 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-300">
    <svg class="mt-0.5 h-4 w-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
    </svg>
    <p class="flex-1">No has configurado un canal bulk. Los correos usarán tu canal primario, lo cual no es ideal para volumen.
      <button (click)="openBulkModal()" class="underline font-medium">Configurar ahora</button>.
    </p>
  </div>
}

<!-- FILTER CHIPS -->
<div class="flex flex-wrap items-center gap-2 mb-4">
  <button (click)="setFilter('ALL')"
          class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors"
          [class.bg-brand-500]="activeFilter === 'ALL'"
          [class.text-white]="activeFilter === 'ALL'"
          [class.border]="activeFilter !== 'ALL'"
          [class.border-gray-300]="activeFilter !== 'ALL'"
          [class.bg-white]="activeFilter !== 'ALL'"
          [class.text-gray-600]="activeFilter !== 'ALL'"
          [class.dark:bg-gray-800]="activeFilter !== 'ALL'"
          [class.dark:text-gray-300]="activeFilter !== 'ALL'"
          [class.dark:border-gray-600]="activeFilter !== 'ALL'"
          [class.hover:bg-gray-50]="activeFilter !== 'ALL'">
    @if (activeFilter === 'ALL') {
      <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
    }
    Todos los correos
  </button>
  @for (s of statusOrder; track s) {
    <button (click)="setFilter(s)"
            class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors border"
            [class.bg-brand-500]="activeFilter === s"
            [class.text-white]="activeFilter === s"
            [class.border-brand-500]="activeFilter === s"
            [class.bg-white]="activeFilter !== s"
            [class.text-gray-600]="activeFilter !== s"
            [class.border-gray-300]="activeFilter !== s"
            [class.dark:bg-gray-800]="activeFilter !== s"
            [class.dark:text-gray-300]="activeFilter !== s"
            [class.dark:border-gray-600]="activeFilter !== s"
            [class.hover:bg-gray-50]="activeFilter !== s">
      <span class="w-2 h-2 rounded-full flex-shrink-0"
            [class]="activeFilter === s ? 'bg-white opacity-80' : statusDotClass(s)"></span>
      {{ statusLabel(s) }}
    </button>
  }
</div>

<!-- FOLDER PANEL -->
@if (folderPanelOpen) {
  <div class="mb-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 overflow-hidden">
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/60">
      <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Carpetas</h3>
      <button (click)="toggleFolderPanel()" class="text-gray-400 hover:text-gray-700 dark:hover:text-white">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <div class="p-4 space-y-2">
      <!-- All campaigns (no folder filter) -->
      <button (click)="setFolderFilter(null)"
              class="w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors"
              [class.bg-brand-500]="activeFolderId === null"
              [class.text-white]="activeFolderId === null"
              [class.hover:bg-gray-100]="activeFolderId !== null"
              [class.dark:hover:bg-gray-800]="activeFolderId !== null"
              [class.text-gray-700]="activeFolderId !== null"
              [class.dark:text-gray-300]="activeFolderId !== null">
        <span class="flex items-center gap-2">
          <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
          </svg>
          Todos los correos
        </span>
        <span class="text-xs opacity-60">{{ campaigns.length }}</span>
      </button>

      <!-- Folder list -->
      @for (folder of folders; track folder.id) {
        <div class="flex items-center gap-1 group">
          @if (folderEditingId === folder.id) {
            <input type="text" [(ngModel)]="folderEditName"
                   (keydown.enter)="saveEditFolder(folder)"
                   (keydown.escape)="folderEditingId = null"
                   (blur)="saveEditFolder(folder)"
                   class="flex-1 rounded-lg border border-teal-400 px-3 py-1.5 text-sm bg-white dark:bg-gray-800 dark:text-white focus:outline-none"
                   autofocus />
          } @else {
            <button (click)="setFolderFilter(folder.id)"
                    class="flex-1 flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors"
                    [class.bg-teal-600]="activeFolderId === folder.id"
                    [class.text-white]="activeFolderId === folder.id"
                    [class.hover:bg-gray-100]="activeFolderId !== folder.id"
                    [class.dark:hover:bg-gray-800]="activeFolderId !== folder.id"
                    [class.text-gray-700]="activeFolderId !== folder.id"
                    [class.dark:text-gray-300]="activeFolderId !== folder.id">
              <span class="flex items-center gap-2 min-w-0">
                <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
                </svg>
                <span class="truncate">{{ folder.name }}</span>
              </span>
              <span class="text-xs opacity-60 flex-shrink-0">{{ folder.campaignCount }}</span>
            </button>
            <div class="hidden group-hover:flex items-center gap-0.5 flex-shrink-0">
              <button *appHasPermission="'campaigns:edit'" (click)="startEditFolder(folder)" title="Renombrar"
                      class="p-1 rounded text-gray-400 hover:text-gray-700 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </button>
              <button *appHasPermission="'campaigns:delete'" (click)="deleteFolder(folder)" title="Eliminar"
                      class="p-1 rounded text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a2 2 0 012-2h2a2 2 0 012 2v3"/>
                </svg>
              </button>
            </div>
          }
        </div>
      }

      @if (folders.length === 0) {
        <p class="px-3 py-2 text-xs text-gray-400">Aún no hay carpetas creadas.</p>
      }

      <!-- Create new folder -->
      <div class="pt-2 border-t border-gray-100 dark:border-gray-800 flex items-center gap-2">
        <input type="text" [(ngModel)]="newFolderName" placeholder="Nueva carpeta..."
               (keydown.enter)="createFolder()"
               class="flex-1 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm dark:text-white focus:outline-none focus:border-teal-400">
        <button [appDisableWithoutPermission]="'campaigns:create'" (click)="createFolder()" [disabled]="!newFolderName.trim() || creatingFolder"
                class="rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-teal-700 disabled:opacity-50 transition-colors">
          Crear
        </button>
      </div>
    </div>
  </div>
}

<!-- SEARCH + EXPORT -->
<div class="flex flex-wrap items-center justify-end gap-2 mb-4">
  <div class="flex items-center gap-2 px-3.5 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md w-72">
    <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
    </svg>
    <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar por nombre o asunto…"
           class="flex-1 border-none outline-none text-sm bg-transparent dark:text-white placeholder:text-gray-400">
  </div>
  <button (click)="exportCsv()" title="Exportar correos a CSV"
          class="inline-flex items-center gap-2 px-3.5 py-2 rounded-md text-sm font-medium text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
      <polyline points="7 10 12 15 17 10"/>
      <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
    Exportar
  </button>
</div>

@if (error) {
  <div class="mb-4 rounded-lg bg-red-50 dark:bg-red-900/20 p-3 text-sm text-red-700 dark:text-red-300">{{ error }}</div>
}

<!-- BULK ACTIONS BAR -->
@if (selectedCampaigns.size > 0) {
  <div class="mb-3 flex items-center gap-3 rounded-xl border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 px-4 py-2.5">
    <span class="text-sm font-medium text-blue-700 dark:text-blue-300">
      {{ selectedCampaigns.size }} correo(s) seleccionado(s)
    </span>
    <!-- Inc 1: abre un modal con las carpetas. Antes era un dropdown cuyo clic burbujeaba
         al <div (click)="moveToFolderMenuId = null"> raíz y se cerraba en el mismo evento. -->
    <button (click)="openBulkMoveModal(); $event.stopPropagation()"
            class="inline-flex items-center gap-1.5 rounded-lg border border-blue-300 dark:border-blue-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-xs font-medium text-blue-700 dark:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
      </svg>
      Mover a carpeta
    </button>
    <button (click)="selectedCampaigns.clear()"
            class="ml-auto text-xs text-gray-500 hover:text-gray-700 dark:hover:text-white transition-colors">
      Limpiar selección
    </button>
  </div>
}

@if (loading) {
  <div class="space-y-1">
    @for (i of [1,2,3,4,5]; track i) {
      <div class="h-14 animate-pulse rounded-lg bg-gray-100 dark:bg-gray-800"></div>
    }
  </div>
} @else {
  <div class="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
    <table class="w-full text-sm border-collapse">
      <thead>
        <tr class="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <th class="w-10 px-4 py-3 text-center">
            <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)"
                   class="w-4 h-4 cursor-pointer accent-gray-600">
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Nombre del correo
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Estado
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Destinatarios
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Tasa de apertura
          </th>
          <th class="px-4 py-3 text-left text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Última actualización ↓
          </th>
          <th class="px-4 py-3 text-right text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-gray-700/50">
        @if (filteredCampaigns.length === 0) {
          <tr>
            <td colspan="7" class="px-4 py-16 text-center">
              <svg class="mx-auto mb-3 h-10 w-10 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <p class="text-sm font-semibold text-gray-900 dark:text-white/90">
                @if (campaigns.length === 0) { Aún no hay correos de marketing } @else { Sin resultados con esos filtros }
              </p>
              @if (campaigns.length === 0) {
                <button *appHasPermission="'campaigns:create'" (click)="newCampaign()"
                        class="mt-3 inline-flex items-center gap-2 rounded-md bg-brand-500 dark:bg-white px-4 py-2 text-sm font-semibold text-white dark:text-gray-900 hover:bg-gray-800 transition-colors">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                  </svg>
                  Crear correo
                </button>
              }
            </td>
          </tr>
        }
        @for (c of filteredCampaigns; track c.id) {
          <tr class="group hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
              [class.bg-blue-50]="selectedCampaigns.has(c.id)"
              [class.dark:bg-blue-900/10]="selectedCampaigns.has(c.id)"
              (click)="openDetail(c)">
            <!-- Checkbox -->
            <td class="w-10 px-4 py-3.5 text-center" (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="selectedCampaigns.has(c.id)"
                     (change)="toggleSelect(c.id, $event)"
                     class="w-4 h-4 cursor-pointer accent-gray-600">
            </td>
            <!-- Name + subject -->
            <td class="px-4 py-3.5">
              <div class="flex items-center gap-2.5 min-w-0">
                <span class="w-2.5 h-2.5 rounded-full flex-shrink-0" [class]="deliveryDotClass(c)"></span>
                <div class="min-w-0 flex-1">
                  <a class="text-blue-600 dark:text-blue-400 hover:underline font-medium"
                     (click)="$event.stopPropagation(); openDetail(c)">{{ c.name }}</a>
                  @if (c.subject) {
                    <p class="text-xs text-gray-400 dark:text-gray-500 truncate mt-0.5">{{ c.subject }}</p>
                  }
                </div>
              </div>
            </td>
            <!-- Estado (badge derivado de la entrega real, Inc 5) -->
            <td class="px-4 py-3.5">
              <span class="inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium"
                    [class]="deliveryBadgeClass(c)">
                {{ deliveryLabel(c) }}
              </span>
            </td>
            <!-- Destinatarios (Inc 13) -->
            <td class="px-4 py-3.5 text-gray-600 dark:text-gray-300">{{ recipients(c) }}</td>
            <!-- Tasa de apertura -->
            <td class="px-4 py-3.5 text-gray-600 dark:text-gray-300">{{ openRate(c) }}</td>
            <!-- Última actualización -->
            <td class="px-4 py-3.5 text-gray-500 dark:text-gray-400 text-xs">{{ formatUpdatedAt(c.updatedAt) }}</td>
            <!-- Acciones (al final, Inc 2) -->
            <td class="px-4 py-3.5">
                <div class="flex-shrink-0 flex items-center justify-end gap-0.5 opacity-70 group-hover:opacity-100 transition-opacity"
                     (click)="$event.stopPropagation()">
                  <button (click)="openDetail(c)" title="Ver detalle"
                          class="rounded p-1.5 text-gray-400 hover:bg-blue-50 hover:text-blue-600 dark:hover:bg-blue-900/20 dark:hover:text-blue-400 transition-colors">
                    <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </button>
                  <!-- Inc 36: el botón "Envío" desapareció junto con su pestaña.
                       "Ver detalle" abre el modal, donde los destinatarios viven
                       dentro de la pestaña "Métricas". -->
                  <span class="w-px h-4 bg-gray-200 dark:bg-gray-700 mx-0.5"></span>
                  @if (canEdit(c)) {
                    <button [appDisableWithoutPermission]="'campaigns:edit'" (click)="edit(c)" title="Editar"
                            class="rounded p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors">
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                  }
                  <button [appDisableWithoutPermission]="'campaigns:create'" (click)="duplicate(c)" title="Duplicar"
                          class="rounded p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors">
                    <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                  </button>
                  @if (canCancel(c)) {
                    <button [appDisableWithoutPermission]="'campaigns:edit'" (click)="cancel(c)" title="Cancelar"
                            class="rounded p-1.5 text-gray-400 hover:bg-amber-50 hover:text-amber-600 dark:hover:bg-amber-900/20 dark:hover:text-amber-400 transition-colors">
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </button>
                  }
                  @if (canDelete(c)) {
                    <button [appDisableWithoutPermission]="'campaigns:delete'" (click)="remove(c)" title="Eliminar"
                            class="rounded p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20 dark:hover:text-red-400 transition-colors">
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a2 2 0 012-2h2a2 2 0 012 2v3" />
                      </svg>
                    </button>
                  }
                  <!-- Move to folder -->
                  <div class="relative">
                    <button (click)="moveToFolderMenuId = moveToFolderMenuId === c.id ? null : c.id"
                            title="Mover a carpeta"
                            class="rounded p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors">
                      <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
                      </svg>
                    </button>
                    @if (moveToFolderMenuId === c.id) {
                      <div class="absolute right-0 top-full mt-1 w-48 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-dropdown py-1"
                           (click)="$event.stopPropagation()">
                        <button (click)="moveCampaignToFolder(c, null)"
                                class="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                          <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                          </svg>
                          Sin carpeta
                        </button>
                        @for (folder of folders; track folder.id) {
                          <button (click)="moveCampaignToFolder(c, folder.id)"
                                  class="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                                  [class.font-semibold]="c.folderId === folder.id"
                                  [class.text-teal-600]="c.folderId === folder.id">
                            <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
                            </svg>
                            {{ folder.name }}
                            @if (c.folderId === folder.id) { <span class="ml-auto text-teal-500">✓</span> }
                          </button>
                        }
                        @if (folders.length === 0) {
                          <p class="px-3 py-2 text-xs text-gray-400">Sin carpetas creadas.</p>
                        }
                      </div>
                    }
                  </div>
                </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<!-- Inc 1: modal "Mover a carpeta" para la selección múltiple -->
<app-modal [isOpen]="bulkMoveModalOpen" (close)="closeBulkMoveModal()" className="max-w-md mx-4 p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Mover a carpeta</h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
    Elige la carpeta de destino para {{ selectedCampaigns.size }} correo(s) seleccionado(s).
  </p>

  <div class="mt-5 max-h-72 space-y-1 overflow-y-auto" role="radiogroup" aria-label="Carpeta de destino">
    @for (folder of folders; track folder.id) {
      <label class="flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors"
             [class.border-brand-500]="bulkMoveTarget === folder.id"
             [class.bg-brand-50]="bulkMoveTarget === folder.id"
             [class.border-gray-200]="bulkMoveTarget !== folder.id"
             [class.dark:border-gray-700]="bulkMoveTarget !== folder.id">
        <input type="radio" name="bulkMoveTarget" [value]="folder.id" [(ngModel)]="bulkMoveTarget"
               class="h-4 w-4 accent-brand-500">
        <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"/>
        </svg>
        <span class="flex-1 truncate text-gray-800 dark:text-gray-200">{{ folder.name }}</span>
        <span class="text-xs text-gray-400">{{ folder.campaignCount }}</span>
      </label>
    }
    <label class="flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors"
           [class.border-brand-500]="bulkMoveTarget === 'NONE'"
           [class.bg-brand-50]="bulkMoveTarget === 'NONE'"
           [class.border-gray-200]="bulkMoveTarget !== 'NONE'"
           [class.dark:border-gray-700]="bulkMoveTarget !== 'NONE'">
      <input type="radio" name="bulkMoveTarget" value="NONE" [(ngModel)]="bulkMoveTarget"
             class="h-4 w-4 accent-brand-500">
      <span class="flex-1 text-gray-600 dark:text-gray-300">Sin carpeta (quitar de su carpeta)</span>
    </label>
    @if (folders.length === 0) {
      <p class="px-1 pt-2 text-xs text-gray-400">Aún no hay carpetas creadas. Créalas con el botón "Carpetas".</p>
    }
  </div>

  <div class="mt-6 flex justify-end gap-3">
    <button (click)="closeBulkMoveModal()"
            class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>
    <button (click)="confirmBulkMove()" [disabled]="bulkMoveTarget === null"
            class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60">
      Mover
    </button>
  </div>
</app-modal>

<app-bulk-channel-modal [isOpen]="bulkModalOpen" (close)="closeBulkModal()" (saved)="onBulkSaved($event)" />

<!-- Detalle del correo en modal (Inc 29). También lo abre el deep-link /marketing-email/:id. -->
<app-campaign-detail-modal
  [isOpen]="showDetailModal"
  [campaignId]="detailCampaignId"
  [initialTab]="detailInitialTab"
  (close)="closeDetail()"
  (changed)="onDetailChanged()"
  (tabChange)="onDetailTabChange($event)">
</app-campaign-detail-modal>
</div>
